import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { Modal, Form, Input, Select, Button, message, Row, Col } from "antd";
import { ExclamationCircleTwoTone } from "@ant-design/icons";
import InputMask from "react-input-mask";
import { createLoadingSelector } from "../../store/api/selectors";
import {
  setCompany,
  putCompany,
  getCompanies,
  clearMessageModal,
} from "../../views/actions";
import {
  formatDateString,
  formatTimeString,
  maskCnpj,
  normalizeCnpj,
  validarCNPJ,
} from "../../helpers/functions";

const Option = Select.Option;

const initialValues = {
  formData: {
    RazaoSocial: "",
    Cnpj: "",
    Ie: "",
    Uf: "",
  },

  errosRazaoSocial: null,
  errosCnpj: null,
  errosUF: null,

  disabledButton: true,
  moduloIcms: !!sessionStorage.getItem("icmsModule"),
};

class ModalCompany extends Component {
  state = initialValues;

  componentDidUpdate(prevProps) {
    const { formData } = this.state,
      { statusCompany, closeModal, data } = this.props,
      { pathname } = this.props.location;

    if (statusCompany === 200 && prevProps.location.pathname === pathname) {
      sessionStorage.setItem("eRecuperadorCompany", JSON.stringify(data));
      sessionStorage.setItem("eRecuperadorActiveTabCompany", 2);
      this.props.history.push(`/empresa/${formData.Cnpj}`);
      closeModal();
      this.setState({
        ...initialValues,
        moduloIcms: !!sessionStorage.getItem("icmsModule"),
      });
      this.props.getCompanies();
    }
  }

  formValidate = () => {
    let valido = 0;

    valido = this.validateRazaoSocial(valido);
    valido = this.validateCnpj(valido);
    valido = this.validateUF(valido);

    if (valido !== 0) this.setState({ disabledButton: true });
    else this.setState({ disabledButton: false });

    return valido;
  };

  validateRazaoSocial = (valido) => {
    this.setState({ errosRazaoSocial: null });

    const { RazaoSocial } = this.state.formData;

    if (!RazaoSocial || RazaoSocial.replaceAll(" ", "").length < 2) {
      valido++;
      this.setState({ errosRazaoSocial: "Razão Social Inválida" });
    }

    return valido;
  };

  validateCnpj = (valido) => {
    this.setState({ errosCnpj: null });

    const { Cnpj } = this.state.formData;

    if (!Cnpj) {
      valido++;
      this.setState({ errosCnpj: "CNPJ vazio" });
      return valido;
    }

    var cnpj = Cnpj;
    cnpj = cnpj.replaceAll(" ", "");
    cnpj = cnpj.replaceAll(".", "");
    cnpj = cnpj.replaceAll("-", "");
    cnpj = cnpj.replaceAll("/", "");
    cnpj = cnpj.replaceAll("_", "");

    if (!validarCNPJ(cnpj)) {
      valido++;
      this.setState({ errosCnpj: "CNPJ Inválido" });
    }

    return valido;
  };

  validateUF = (valido) => {
    this.setState({ errosUF: null });

    const { moduloIcms } = this.state;
    const { Uf } = this.state.formData;

    if (moduloIcms && !Uf) {
      valido++;
      this.setState({ errosUF: "UF é obrigatória" });
    }

    return valido;
  };

  handleChangeRazaoSocial = (event) => {
    const value = event.target.value;
    this.setState(
      { formData: { ...this.state.formData, RazaoSocial: value } },
      () => this.formValidate()
    );
  };

  handleChangeCnpj = (event) => {
    const value = maskCnpj(normalizeCnpj(event.target.value).substring(0, 14));
    this.setState({ formData: { ...this.state.formData, Cnpj: value } }, () =>
      this.formValidate()
    );
  };

  handleChangeIe = (event) => {
    const value = event.target.value;
    this.setState({ formData: { ...this.state.formData, Ie: value } }, () =>
      this.formValidate()
    );
  };

  handleSelectUF(value) {
    this.setState(
      {
        formData: { ...this.state.formData, Uf: value },
      },
      () => {
        this.formValidate();
      }
    );
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { formData } = this.state;

    if (this.formValidate() !== 0) {
      message.error("Existem algum campo inválido!");
      return;
    }

    formData.Cnpj = normalizeCnpj(formData.Cnpj);
    formData.Ie = formData.Ie.replaceAll(".", "");

    this.props.setCompany(formData);
  };

  handleCloseModal = () => {
    const { closeModal } = this.props;
    closeModal();
    this.setState({
      ...initialValues,
      moduloIcms: !!sessionStorage.getItem("icmsModule"),
    });
    this.props.clearMessageModal();
    this.props.getCompanies();
  };

  render() {
    const { visible, closeModal, isFetching, data } = this.props;
    const { formData, disabledButton, moduloIcms } = this.state;

    const showMessageModal = data?.DataExclusao;

    return (
      <Modal
        title={
          !showMessageModal
            ? "Cadastrar empresa"
            : "Alerta! Processo de Exclusão em Andamento"
        }
        visible={visible}
        closable={false}
        footer={false}
        width={650}
      >
        {!showMessageModal ? (
          <Form id="formCompany" onSubmit={this.handleSubmit}>
            <div className="row">
              <div className="form-group col-md-6">
                <label className="col-form-label">Razão Social*</label>
                <Input
                  className="form-control"
                  name="RazaoSocial"
                  maxLength="100"
                  value={formData.RazaoSocial}
                  onChange={this.handleChangeRazaoSocial}
                />
                <label className="col-form-label-error">
                  {this.state.errosRazaoSocial}
                </label>
              </div>

              <div className="form-group col-md-6">
                <label className="col-form-label">CNPJ*</label>
                <Input
                  className="form-control"
                  name="Cnpj"
                  value={formData.Cnpj || ""}
                  placeholder="__.___.___/____-__"
                  maxLength={18}
                  onChange={this.handleChangeCnpj}
                />
                <label className="col-form-label-error">
                  {this.state.errosCnpj}
                </label>
              </div>

              <div className="form-group col-md-6">
                <label className="col-form-label">IE</label>
                <InputMask
                  className="form-control"
                  name="Ie"
                  value={formData.Ie}
                  onChange={this.handleChangeIe}
                />
              </div>

              <div className="form-group col-md-6">
                <label className="col-form-label">
                  UF{moduloIcms ? "*" : ""}
                </label>
                <Select
                  className="ant-select--custom"
                  name="Uf"
                  value={formData.Uf}
                  onChange={(e) => this.handleSelectUF(e)}
                >
                  <Option value={null}>Selecione um estado</Option>
                  <Option value="AC">Acre</Option>
                  <Option value="AL">Alagoas</Option>
                  <Option value="AP">Amapá</Option>
                  <Option value="AM">Amazonas</Option>
                  <Option value="BA">Bahia</Option>
                  <Option value="CE">Ceará</Option>
                  <Option value="DF">Distrito Federal</Option>
                  <Option value="ES">Espírito Santo</Option>
                  <Option value="GO">Goiás</Option>
                  <Option value="MA">Maranhão</Option>
                  <Option value="MT">Mato Grosso</Option>
                  <Option value="MS">Mato Grosso do Sul</Option>
                  <Option value="MG">Minas Gerais</Option>
                  <Option value="PA">Pará</Option>
                  <Option value="PB">Paraíba</Option>
                  <Option value="PR">Paraná</Option>
                  <Option value="PE">Pernambuco</Option>
                  <Option value="PI">Piauí</Option>
                  <Option value="RR">Roraima</Option>
                  <Option value="RO">Rondônia</Option>
                  <Option value="RJ">Rio de Janeiro</Option>
                  <Option value="RN">Rio Grande do Norte</Option>
                  <Option value="RS">Rio Grande do Sul</Option>
                  <Option value="SC">Santa Catarina</Option>
                  <Option value="SP">São Paulo</Option>
                  <Option value="SE">Sergipe</Option>
                  <Option value="TO">Tocantins</Option>
                </Select>
                <label className="col-form-label-error">
                  {this.state.errosUF}
                </label>
              </div>
            </div>

            <div className="ant-modal-footer">
              <Button type="default" onClick={closeModal}>
                Cancelar
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={isFetching ? true : false}
                disabled={disabledButton}
              >
                Cadastrar
              </Button>
            </div>
          </Form>
        ) : (
          <>
            <Row type="flex" align="middle" justify="center">
              <Col span={2}>
                {" "}
                <ExclamationCircleTwoTone
                  twoToneColor="#faad14"
                  style={{ fontSize: "2.5rem" }}
                />
              </Col>
              <Col span={22}>
                <p>
                  <strong>
                    Foi solicitada a exclusão do CNPJ{" "}
                    <i>{maskCnpj(data.Cnpj)}</i> em{" "}
                    <i>{formatDateString(data.DataExclusao)}</i>, às{" "}
                    <i>{formatTimeString(data.DataExclusao)}</i>.
                  </strong>
                </p>
                <br />
                <p>
                  O novo cadastro do mesmo CNPJ deve aguardar a conclusão do
                  processo de exclusão solicitado, o que pode acontecer em até
                  24 horas, contadas a partir da solicitação de exclusão.
                  <br />
                  No momento, verificamos que ainda existem dados relacionados
                  ao CNPJ pendentes de exclusão, ou seja, o processo de exclusão
                  da empresa está em andamento.
                </p>
                <br />
                <p>Por favor, tente novamente mais tarde.</p>
              </Col>
            </Row>

            <div className="ant-modal-footer">
              <Button type="primary" onClick={this.handleCloseModal}>
                OK
              </Button>
            </div>
          </>
        )}
      </Modal>
    );
  }
}

const loadingSetCompany = createLoadingSelector(["SET_COMPANY"]);

const mapStateToProps = (state) => ({
  data: state.companies.data,
  statusCompany: state.companies.status,
  isFetching: loadingSetCompany(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { setCompany, putCompany, getCompanies, clearMessageModal },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ModalCompany));
